export default import.meta.ROLLDOWN_FILE_URL_dD5xyYJYTjiy6ZDbzgg4Uw